// extracted by mini-css-extract-plugin
module.exports = {"pagination":"pagination_pagination__3zfJj","break":"pagination_break__5gph_","pageLink2":"pagination_pageLink2__894pX","arrows":"pagination_arrows__3TejS"};